import { render, staticRenderFns } from "./passenger-edit.vue?vue&type=template&id=13336144&scoped=true&"
import script from "./passenger-edit.vue?vue&type=script&lang=js&"
export * from "./passenger-edit.vue?vue&type=script&lang=js&"
import style0 from "./passenger-edit.vue?vue&type=style&index=0&id=13336144&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13336144",
  null
  
)

export default component.exports